import { createFileRoute } from '@tanstack/react-router';
import { ApiKeysManager } from '@/components/api-keys-manager';

export const Route = createFileRoute('/_app/account/api-keys')({
  component: () => <ApiKeysManager kind="client" />,
});
